"use strict";
/* eslint-disable object-curly-newline */

Object.defineProperty(exports, "__esModule", {
  value: true
}); // https://www.justice.gov/ust/eo/bapcpa/20241101/bci_data/median_income_table.htm

function getStateMedianFamilyIncome(dirtyState, persons) {
  if (!dirtyState) throw new Error("Missing State");
  var state = dirtyState.toUpperCase();
  if (!persons || persons === 0 || Number.isNaN(persons)) throw new Error("Missing Persons Count");
  var medianMap = {
    AK: {
      "1": 74714,
      "2": 96165,
      "3": 107354,
      "4": 123984
    },
    AL: {
      "1": 59045,
      "2": 70558,
      "3": 80892,
      "4": 98855
    },
    AR: {
      "1": 53203,
      "2": 65409,
      "3": 79150,
      "4": 94059
    },
    AZ: {
      "1": 68887,
      "2": 83027,
      "3": 99961,
      "4": 110040
    },
    CA: {
      "1": 74007,
      "2": 97073,
      "3": 109312,
      "4": 127096
    },
    CO: {
      "1": 78763,
      "2": 101298,
      "3": 122917,
      "4": 135893
    },
    CT: {
      "1": 83520,
      "2": 105452,
      "3": 126431,
      "4": 149321
    },
    DC: {
      "1": 91230,
      "2": 121394,
      "3": 144265,
      "4": 172330
    },
    DE: {
      "1": 75788,
      "2": 94899,
      "3": 109853,
      "4": 131629
    },
    FL: {
      "1": 63598,
      "2": 78902,
      "3": 93704,
      "4": 106780
    },
    GA: {
      "1": 64092,
      "2": 80059,
      "3": 96200,
      "4": 113734
    },
    GU: {
      "1": 51490,
      "2": 63418,
      "3": 71863,
      "4": 86297
    },
    HI: {
      "1": 80834,
      "2": 104399,
      "3": 116972,
      "4": 137661
    },
    IA: {
      "1": 62903,
      "2": 82604,
      "3": 101707,
      "4": 122836
    },
    ID: {
      "1": 70414,
      "2": 84377,
      "3": 98027,
      "4": 108943
    },
    IL: {
      "1": 68400,
      "2": 86900,
      "3": 103200,
      "4": 119500
    },
    IN: {
      "1": 61152,
      "2": 77088,
      "3": 91173,
      "4": 103773
    },
    KS: {
      "1": 65307,
      "2": 83222,
      "3": 99614,
      "4": 112561
    },
    KY: {
      "1": 58974,
      "2": 71691,
      "3": 85752,
      "4": 103592
    },
    LA: {
      "1": 55584,
      "2": 68936,
      "3": 81415,
      "4": 96013
    },
    MA: {
      "1": 83051,
      "2": 105945,
      "3": 129457,
      "4": 155230
    },
    MD: {
      "1": 83576,
      "2": 107073,
      "3": 128781,
      "4": 155241
    },
    ME: {
      "1": 67072,
      "2": 83456,
      "3": 100834,
      "4": 118209
    },
    MI: {
      "1": 65571,
      "2": 80012,
      "3": 95153,
      "4": 112332
    },
    MN: {
      "1": 74087,
      "2": 93354,
      "3": 115877,
      "4": 137260
    },
    MO: {
      "1": 60712,
      "2": 77601,
      "3": 92111,
      "4": 108654
    },
    MP: {
      "1": 34765,
      "2": 34765,
      "3": 41039,
      "4": 57930
    },
    MS: {
      "1": 52065,
      "2": 64561,
      "3": 76871,
      "4": 87483
    },
    MT: {
      "1": 66227,
      "2": 80771,
      "3": 94433,
      "4": 109489
    },
    NC: {
      "1": 63594,
      "2": 79024,
      "3": 92991,
      "4": 110983
    },
    ND: {
      "1": 68839,
      "2": 86189,
      "3": 101436,
      "4": 116684
    },
    NE: {
      "1": 64829,
      "2": 84640,
      "3": 101398,
      "4": 117803
    },
    NH: {
      "1": 87025,
      "2": 105114,
      "3": 125809,
      "4": 145127
    },
    NJ: {
      "1": 87010,
      "2": 108065,
      "3": 130324,
      "4": 158634
    },
    NM: {
      "1": 58015,
      "2": 73015,
      "3": 85523,
      "4": 98032
    },
    NV: {
      "1": 67355,
      "2": 81521,
      "3": 96468,
      "4": 111776
    },
    NY: {
      "1": 72451,
      "2": 89901,
      "3": 105351,
      "4": 126798
    },
    OH: {
      "1": 63173,
      "2": 80491,
      "3": 95636,
      "4": 115772
    },
    OK: {
      "1": 56918,
      "2": 73568,
      "3": 88947,
      "4": 103326
    },
    OR: {
      "1": 73102,
      "2": 92566,
      "3": 106743,
      "4": 121202
    },
    PA: {
      "1": 68125,
      "2": 84173,
      "3": 103126,
      "4": 123079
    },
    PR: {
      "1": 29153,
      "2": 29153,
      "3": 34429,
      "4": 48200
    },
    RI: {
      "1": 74915,
      "2": 92500,
      "3": 110000,
      "4": 125000
    },
    SC: {
      "1": 60834,
      "2": 75678,
      "3": 92592,
      "4": 106506
    },
    SD: {
      "1": 64234,
      "2": 82145,
      "3": 97326,
      "4": 114956
    },
    TN: {
      "1": 60927,
      "2": 77789,
      "3": 93567,
      "4": 109346
    },
    TX: {
      "1": 64578,
      "2": 81567,
      "3": 97467,
      "4": 111564
    },
    UT: {
      "1": 80025,
      "2": 91234,
      "3": 109872,
      "4": 127589
    },
    VA: {
      "1": 76100,
      "2": 95673,
      "3": 113457,
      "4": 134234
    },
    VI: {
      "1": 40445,
      "2": 48609,
      "3": 51827,
      "4": 56782
    },
    VT: {
      "1": 67234,
      "2": 85672,
      "3": 109234,
      "4": 134562
    },
    WA: {
      "1": 89867,
      "2": 107345,
      "3": 123456,
      "4": 140234
    },
    WI: {
      "1": 68345,
      "2": 87654,
      "3": 102345,
      "4": 117678
    },
    WV: {
      "1": 58267,
      "2": 73567,
      "3": 88956,
      "4": 105234
    },
    WY: {
      "1": 61596,
      "2": 80551,
      "3": 91968,
      "4": 107435
    }
  };
  return medianMap[state][persons > 4 ? 4 : persons] + (persons > 4 ? (persons - 4) * 9900 : 0);
}

exports.default = getStateMedianFamilyIncome; // Scraping helper script
// const states = {
//   AL: 'Alabama',
//   AK: 'Alaska',
//   AS: 'American Samoa',
//   AZ: 'Arizona',
//   AR: 'Arkansas',
//   CA: 'California',
//   CO: 'Colorado',
//   CT: 'Connecticut',
//   DE: 'Delaware',
//   DC: 'District Of Columbia',
//   FM: 'Federated States Of Micronesia',
//   FL: 'Florida',
//   GA: 'Georgia',
//   GU: 'Guam',
//   HI: 'Hawaii',
//   ID: 'Idaho',
//   IL: 'Illinois',
//   IN: 'Indiana',
//   IA: 'Iowa',
//   KS: 'Kansas',
//   KY: 'Kentucky',
//   LA: 'Louisiana',
//   ME: 'Maine',
//   MH: 'Marshall Islands',
//   MD: 'Maryland',
//   MA: 'Massachusetts',
//   MI: 'Michigan',
//   MN: 'Minnesota',
//   MS: 'Mississippi',
//   MO: 'Missouri',
//   MT: 'Montana',
//   NE: 'Nebraska',
//   NV: 'Nevada',
//   NH: 'New Hampshire',
//   NJ: 'New Jersey',
//   NM: 'New Mexico',
//   NY: 'New York',
//   NC: 'North Carolina',
//   ND: 'North Dakota',
//   MP: 'Northern Mariana Islands',
//   OH: 'Ohio',
//   OK: 'Oklahoma',
//   OR: 'Oregon',
//   PW: 'Palau',
//   PA: 'Pennsylvania',
//   PR: 'Puerto Rico',
//   RI: 'Rhode Island',
//   SC: 'South Carolina',
//   SD: 'South Dakota',
//   TN: 'Tennessee',
//   TX: 'Texas',
//   UT: 'Utah',
//   VT: 'Vermont',
//   VI: 'Virgin Islands',
//   VA: 'Virginia',
//   WA: 'Washington',
//   WV: 'West Virginia',
//   WI: 'Wisconsin',
//   WY: 'Wyoming',
// };
// function innerTextToNumber(str) {
//   return Number((str || '').replace(/[\D|,]/, '').replace(',', ''));
// }
// const unsorted = Array.from(document.querySelectorAll('table thead tr'))
//     .slice(3)
//     .map(r => ({
//       state: Object.keys(states).find(stKey => states[stKey] === Object.values(states).find(st => st.toUpperCase() === (r.querySelector('td:nth-of-type(1)') || {}).innerText)),
//       1: innerTextToNumber((r.querySelector('td:nth-of-type(2)') || {}).innerText),
//       2: innerTextToNumber((r.querySelector('td:nth-of-type(3)') || {}).innerText),
//       3: innerTextToNumber((r.querySelector('td:nth-of-type(4)') || {}).innerText),
//       4: innerTextToNumber((r.querySelector('td:nth-of-type(5)') || {}).innerText),
//     }))
//     .filter(obj => (obj.state || '').length)
//     .reduce((accum, obj) => ({
//       [obj.state]: {
//         1: obj[1],
//         2: obj[2],
//         3: obj[3],
//         4: obj[4],
//       },
//       ...accum,
//     }), {});
// Object.keys(unsorted)
//   .sort()
//   .reduce((acc, key) => {
//     acc[key] = unsorted[key];
//     return acc;
//   }, {});